import React from 'react';

interface CircularProgressProps {
  value: number;
  color: string;
  size?: string;
  label?: string;
  subLabel?: string;
  maxValue?: number;
  showPercentage?: boolean;
}

export const CircularProgress: React.FC<CircularProgressProps> = ({ 
  value, 
  color, 
  size = "w-12 h-12", 
  label, 
  subLabel,
  maxValue = 100,
  showPercentage = true
}) => {
  const percentage = Math.min((value / maxValue) * 100, 100);
  
  return (
    <div className="flex flex-col items-center">
      <div className={`relative ${size}`}>
        <svg className="w-full h-full" viewBox="0 0 36 36">
          <path
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            fill="none"
            stroke={'var(--gauge-track)'}
            strokeWidth="3"
          />
          <path
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            fill="none"
            stroke={color}
            strokeWidth="3"
            strokeDasharray={`${percentage}, 100`}
            className="rotate-[-90deg] origin-center"
          />
        </svg>
        {label && (
          <div className="absolute inset-0 flex flex-col items-center justify-center text-[11px] font-medium text-white">
            {showPercentage ? `${Math.round(percentage)}%` : label}
          </div>
        )}
      </div>
       {subLabel && (
        <div className="mt-1 text-center">
          <div className="text-[10px] text-glass-400">{subLabel}</div>
        </div>
      )}
    </div>
  );
};
